<template>
  <v-main>
    <v-alert id="alert" v-model="alert.isAlert" :type="alert.type" closable class="row">{{ alert.message }}</v-alert>
    <v-overlay :model-value="showOverlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-container fluid>
      <h1>マニュアル</h1>
    </v-container>
    <v-container fluid>
      <v-card name="manual">
        <v-data-table class="elevation-1" :headers="headers" :items="manualList" density="compact">
          <template #headers></template>
          <template #[`item.action`]="props">
            <div class="download-button">
              <v-btn color="primary" @click="download(props.item)"> ダウンロード </v-btn>
            </div>
          </template>
          <template #bottom></template>
        </v-data-table>
      </v-card>
    </v-container>
  </v-main>
</template>

<script>
import Api from '@/constants/api';

export default {
  data: () => ({
    headers: [
      { title: 'マニュアル名', key: 'title', sortable: true, filterable: false, width: '10%' },
      { title: '', key: 'action', sortable: false, filterable: false, width: '10%' },
    ],
    manualList: [{ id: 1, title: '契約者マイページ操作マニュアル' }],
    showOverlay: false,
    isButtonDisabled: false,
    loginUser: {
      billinggroupId: '',
      roleId: -1,
    },
    alert: { isAlert: false, type: 'success', message: '' },
  }),
  created: async function () {
    this.showOverlay = true;
    try {
      await this.createManualList();
    } finally {
      this.showOverlay = false;
    }
  },
  methods: {
    createManualList: async function () {},
    download: async function (manual) {
      this.isButtonDisabled = true;
      const response = await this.axios.get(Api.PATH_MANUAL, {
        responseType: 'blob',
        headers: { Accept: 'application/pdf' },
        params: {
          manual_id: manual.id,
        },
      });
      const type = response.headers['content-type'];
      const blob = new Blob([response.data], { type: type });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      const extension = type.split('/')[1];
      link.download = manual.title + '.' + extension;
      link.click();
      this.isButtonDisabled = false;
    },
    showAlert: function (type, message) {
      this.alert.isAlert = true;
      this.alert.type = type;
      this.alert.message = message;
    },
  },
};
</script>
<style scoped>
.container {
  width: 95%;
}
.download-button {
  text-align: right;
  padding: 10px;
}
.v-overlay {
  align-items: center;
  justify-content: center;
}
</style>
